import React  from "react";

import { Link } from "react-router-dom";


function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          
          {/* About Section */}
          <div className="col-md-5">
            <div className="footer-about">
              <h2>About Us</h2>
              <p>
                Office Open Hours:<br/>
                Mon - Fri : 08:00 AM To 08:00 PM
              </p>
              <br />
              <p><i className="fa fa-map-marker-alt"></i> LTH IT SOLUTIONS PVT. LTD. <br/> Delhi Gate, Infront Of Bharat Gas Agancy, Nagar,<br/> Ahilanagar 414001</p>
              <p><i className="fa fa-phone-alt"></i> +91 9765260001</p>
              <p><i className="fa fa-envelope"></i> hr@lthitsolutions.com</p>
            </div>
          </div>

          {/* Links Section */}
          <div className="col-md-7">
            <div className="row">
              
              <div className="col-md-6">
                <div className="footer-link">
                  <h2>Useful Link</h2>
                  <Link to="/about">About Us</Link>
                  <Link to="/story">Our Story</Link>
                  <Link to="/services">Our Services</Link>
                  <Link to="/portfolio">Our Portfolio</Link>
                  <Link to="/team">Our Team</Link>
                  <Link to="/contact">Contact Us</Link>
                </div>
              </div>

              <div className="col-md-6">
                <div className="footer-link">
                  <h2>Useful Link</h2>
                  <Link to="/">Our Clients</Link>
                  <Link to="/">Clients Review</Link>
                  <Link to="/">Ongoing Customer</Link>
                  <Link to="/">Customer Support</Link>
                  <Link to="/">FAQs</Link>
                  <Link to="/">Site Map</Link>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

     
      <div className="container copyright">
        <div className="row">
          <div className="col-md-6">
            <p>
              <a href="https://lthitsolutions.com">LTH IT SOLUTIONS PVT. LTD. </a>, All Right Reserved.
            </p>
          </div>
          <div className="col-md-6">
            <p>
              Designed By <a href="https://lthitsolutions.com">LAKSH TECH HUB.</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;